import { languageStringMap } from '../constants/languageSwitcherStrings';

export function getSwitchLanguageString(language) {
    const langPrefix = language.split('_')[0];
    return languageStringMap[langPrefix];
}

export function getSwitchLanguageURL(language) {
    let searchParams = window.location.search || '?';
    searchParams = searchParams.replace(/&mons_sel_locale=[a-z]{2}_[A-Z]{2}/g, '');
    const queryParams = searchParams + `&mons_sel_locale=${language}`;

    return window.location.pathname + queryParams + (window.location.hash || '');
}
